export default __webpack_public_path__ + "static/media/Niveditha.b88106f2.jpg";